/**
 * Created by alberto on 2015-08-20.
 */
define('payment/paymentOperationMetadata',['jquery', 'all/comeon'], function ($, comeon) {

	'use strict';

	var paymentOperationMetadata = {};
	var isFirstPaymentOperation;

	function checkPaymentOperation(paymentType) {
		var parameters = {paymentOperation: paymentType};
		var ajaxPromise = comeon.promise.create();

		$.get('/pp?flow=IsFirstMobilePaymentOperation',parameters,function(result){
			ajaxPromise.resolve(result);
		});

		return ajaxPromise.promise();
	}

	paymentOperationMetadata.queryFirstPaymentOperation = function(paymentType){
		var firstPaymentOperationMetadataPromise = comeon.promise.create();
		$.when(checkPaymentOperation(paymentType)).done(function(result){
			firstPaymentOperationMetadataPromise.resolve(result.isFirstPaymentOperation);
		});
		isFirstPaymentOperation = firstPaymentOperationMetadataPromise.promise();
	};
	paymentOperationMetadata.checkFirstPaymentOperation = function(){
		return isFirstPaymentOperation;
	};
	return paymentOperationMetadata;
});

